import EL from '../../../../../EL/EL.js';
import TR from '../../../../../DOM/table/TGROUP/ROW/TR.js';
import { makeStruct } from '../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../enums/ModelData.js';
import { COLUMNTYPE } from '../../../../../../enums/COLUMNTYPE.js';
// Model Structure
export const columnAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['colspan'], // Default colspan is 1
    ['rowspan'] // Default rowspan is 1
]);
export const columnData = makeDataStruct([
    ['text'],
    ['datatype', COLUMNTYPE.VARCHAR], // Default data type is string
    ['length', 255], // Default length for VARCHAR
]);
export const columnModel = makeStruct([
    ['attributes', columnAttr],
    ['data', columnData]
]);
// Simplified Model
export function column(text, name, className, colspan, rowspan, datatype, length) {
    return {
        attributes: columnAttr(name, className, colspan, rowspan),
        data: columnData(text, datatype, length)
    };
}
/** A Column that exists inside a Row */
export default class COLUMN extends EL {
    constructor(node, element, model) {
        super(node, element, model);
        this.addClass('table-column');
        //this.on('activate', () => console.log('Activated Column'));
        //this.on('deactivate', () => console.log('Deactivated Column'));
    }
    /** Returns this row's table-group */
    getRow() {
        return this.node;
    }
    getName() {
        return this.attributes.name || '';
    }
}
export { EL, TR };
